import { h, render} from 'preact';
import "preact/debug";

import Item from "./models/item.js"

import Tools from "./tools.jsx"

import "./styles/reset.css"
import "./styles/base.css"
import "./styles/gridded.css"
import "./styles/matching.css"
import "./styles/mc.css"
import "./styles/ordering.css"
import "./styles/gap-match.css"
import "./styles/loading-state.css"
import "./styles/essay.css"
import "./styles/fill-in-the-blank.css"
import "./styles/color-picker.css"
import "./styles/color-picker.css"
import "./styles/popup.css"
import "./styles/tts-tool.css"
import "./styles/highlighter-tool.css"
import "./styles/notepad-tool.css";
import "./styles/calculator-tool.css";
import "./styles/embed-tool.css";
import "./styles/floating-window.css";
import "./styles/multipart.css";

import HighlightEditor from './highlight-editor.js';
import EssayEditor  from '../essay-editor/app.tsx';
import QuestionWrapper from './question-wrapper.jsx';
import omissionCheck from './utils/omission-check.js';

/**
 * @typedef {import("./shared-types.js").LegacyPerformanceEventResponse} LegacyPerformanceEventResponse
 */

/**
 * @typedef {import("./shared-types.js").ItemJSON} ItemJSON
 */

/**
 * @typedef {import("./shared-types.js").TeacherResponse} TeacherResponseObject
 */

/**
 * @typedef {import("./shared-types.js").ScoringData} ScoringDataObject
 */

class MMItemPlayer {
  /**
   * @param {{
    * source: string,
    * data?: ItemJSON,
    * element: string,
    * dragScrollContainer?: string,
    * didRender: function,
    * teacherResponseDidFinishEdit: (teacherResponse: TeacherResponseObject) => Promise | undefined,
    * teacherResponseDidChange: function | undefined,
    * responseDidChange:  function(import("./shared-types.js").StudentResponse): void | undefined,
    * legacyPerformanceEventResponse?: LegacyPerformanceEventResponse[],
    * studentResponse: import("./shared-types.js").StudentResponse,
    * teacherResponse: TeacherResponseObject | undefined,
    * scoringData: ScoringDataObject | undefined,
    * readOnly: boolean,
    * useRequestStore: boolean,
    * id?: string,
    * type?: string
    * mode?: 'teacher-facing' | 'student-facing' | 'preview' | 'student-facing-report'
    * hidePoints: boolean,
    * hideAllAnswers: boolean,
    * hideCorrectAnswers: boolean,
    * hideResponse?: boolean,
    * bodyDiff?: any[],
    * allowChoiceElimination?: boolean
   * }} options
   *
   */
  constructor(options) {
    this.source = options.data ? undefined : options.source || this.buildUrl( options.id, options.type );
    this.data = options.data;
    this.elementString = options.element;
    /**
     * @type HTMLElement | null
     */
    let _element = document.querySelector(this.elementString)
    if(_element) {
      this.element = _element;
    }

    if(!this.element) {
      throw "Element Not Found"
    }
    this.dragScrollContainer = options.dragScrollContainer;
    this.didRender = options.didRender || (() => {});
    this.response = options.studentResponse;
    this.legacyPerformanceEventResponse = options.legacyPerformanceEventResponse;
    this.teacherResponse = options.teacherResponse;
    this.scoringData = options.scoringData;
    this.readOnly = options.readOnly || false;
    this.useRequestStore = options.useRequestStore || true;
    this.mode = options.mode || "student-facing"
    this.hidePoints = options.hidePoints || false;
    this.hideAllAnswers = options.hideAllAnswers || false;
    this.hideCorrectAnswers = options.hideCorrectAnswers || false;  
    this.hideResponse = options.hideResponse || false;
    this.teacherResponseDidChange = options.teacherResponseDidChange || function() {};
    this.teacherResponseDidFinishEdit = options.teacherResponseDidFinishEdit || function() {};
    /** @type {function(import("./shared-types.js").StudentResponse): void} */
    let _responseDidChange = function() {};
    this.responseDidChange = options.responseDidChange || _responseDidChange;
    this.bodyDiff = options.bodyDiff
    this.allowChoiceElimination = options.allowChoiceElimination || false;
    this.render();
  }


  /**
   * @param {boolean} tf
   */
  setReadOnly(tf) {
    this.readOnly = tf;
    this.clear();
    this.render();
  }

  /**
   * @param {string|undefined} id
   * @param {string|undefined} type
   * @returns String
   */
  buildUrl( id, type ) {
    if( id && type ) {
      if(type == "QuestionVersion") {
        return `/-/question_versions/${id}?include=reference_material`
      } else if( type == "Question" ) {
        return `/-/questions/${id}?include=reference_material`
      } else {
        throw `Unsupported Type #{type}`
      }
    } else {
      throw `Missing required options id, and type`
    }
  }

  render() {
    render(<QuestionWrapper
      source={this.source}
      data={this.data}
      studentResponse={this.response}
      teacherResponse={this.teacherResponse}
      legacyPerformanceEventResponse={this.legacyPerformanceEventResponse}
      scoringData={this.scoringData}
      didRender={this.didRender}
      readOnly={this.readOnly}
      responseDidChange={this.responseDidChange}
      teacherResponseDidChange={this.teacherResponseDidChange}
      teacherResponseDidFinishEdit={this.teacherResponseDidFinishEdit}
      mode={this.mode}
      hideAllAnswers={this.hideAllAnswers}
      hideCorrectAnswers={this.hideCorrectAnswers}
      hidePoints={this.hidePoints}
      hideResponse={this.hideResponse}
      dragScrollContainer={this.dragScrollContainer}
      bodyDiff={this.bodyDiff}
      allowChoiceElimination={this.allowChoiceElimination}
      />, this.element)
  }

  destroy() {
    render(null, this.element)
  }

  clear() {
    this.element.innerText = "";
  }
}

MMItemPlayer.Tools = Tools;
MMItemPlayer.HighlightEditor = HighlightEditor;
MMItemPlayer.EssayEditor = EssayEditor;
MMItemPlayer.omissionCheck = omissionCheck;

//@ts-ignore
window["MMItemPlayer"] = MMItemPlayer;
export default MMItemPlayer;
